<div class="column content-container">
	<div class="content-container-header">
		<h3 i18n="@@addRoleConfirmation-confirmation"><b>Confirmation</b></h3>
		<mat-divider></mat-divider>

		<div class="content-container-body">
			@if (showLoading) {
				<div>
					<mat-spinner diameter="35" style="float: left"></mat-spinner>
					<h3 style="float: left; margin-top: 7px; margin-left: 1em" i18n="@@addRoleConfirmation-loadingMessage">
						Loading...
					</h3>
				</div>
			}

			@if (showSuccess) {
				<div data-automation-id="add-role-confirmation-success-message">
					<b>{{ roleName }}</b
					><ng-container>&nbsp;</ng-container>
					<ng-container i18n="@@addRoleConfirmation-hasBeenAddedAnd">has been added and</ng-container
					><ng-container>&nbsp;</ng-container>{{ users.length }}<ng-container>&nbsp;</ng-container>
					<ng-container [ngPlural]="users.length">
						<ng-template i18n="@@roleDetailConfirmation-userSingular" ngPluralCase="=1">user</ng-template>
						<ng-template i18n="@@roleDetailConfirmation-userPlural" ngPluralCase="other">users</ng-template>
					</ng-container>
					<ng-container>&nbsp;</ng-container>
					<ng-container [ngPlural]="users.length">
						<ng-template i18n="@@addRoleConfirmation-wasAssigned" ngPluralCase="=1">was assigned</ng-template>
						<ng-template i18n="@@addRoleConfirmation-wereAssigned" ngPluralCase="other"
							>were assigned</ng-template
						> </ng-container
					>.<br />
					<br />
					<ng-container i18n="@@addRoleConfirmation-verificationEmailSentToTheFollowing"
						>A verification email has been sent to the following:</ng-container
					><br />
					@for (user of users; track user) {
						<div>
							<b>{{ user.email }}</b>
						</div>
					}
				</div>
			}

			@if (showFailure) {
				<div i18n="@@addRoleConfirmation-roleErrorMessage">
					<h3>
						Error when creating <b>{{ roleName }}.</b>
					</h3>
				</div>
			}

			<div style="margin-top: 24px; margin-bottom: 24px">
				<mat-divider></mat-divider>
			</div>

			<div style="position: sticky; float: left; margin-top: 8px">
				@if (isActiveCompany) {
					<button
						mat-button
						class="primary-button"
						(click)="returnToRoles()"
						i18n="@@addRoleConfirmation-returnToRoles"
						data-automation-id="return-to-roles-button"
					>
						Return to Roles
					</button>
				}
				@if (!isActiveCompany) {
					<button
						mat-button
						class="primary-button"
						(click)="returnToRoles()"
						i18n="@@addRoleConfirmation-returnToCompanyDetails"
						data-automation-id="return-to-company-details-button"
					>
						Return to Company Details
					</button>
				}
			</div>
		</div>
	</div>
</div>
